const millisInSecond = 1000;

export const convertSecondsToMillis = (seconds: number) => seconds * millisInSecond;
